import formatter from "./formatter";
import { toFiniteNumber } from "./number";
import {
  PAYMENT_METHOD_FEE_KEYS,
  type PaymentFeeKey,
  type PaymentMethod,
} from "./paymentMethods";

type PaymentFeePercents = Record<PaymentFeeKey, unknown>;

export const getPaymentFeePercent = (
  paymentMethod: PaymentMethod | undefined,
  feePercents: PaymentFeePercents,
): number =>
  paymentMethod
    ? toFiniteNumber(feePercents[PAYMENT_METHOD_FEE_KEYS[paymentMethod]])
    : 0;

export const calculatePaymentFee = (
  amount: unknown,
  feePercent: unknown,
): number => {
  const amountValue = toFiniteNumber(amount);
  const feePercentValue = toFiniteNumber(feePercent);

  return amountValue > 0
    ? formatter.roundTo2Decimal(feePercentValue * amountValue)
    : 0;
};

export const calculatePaymentTotal = (
  amount: unknown,
  feePercent: unknown,
): number => {
  const amountValue = toFiniteNumber(amount);
  return formatter.roundTo2Decimal(
    amountValue + calculatePaymentFee(amountValue, feePercent),
  );
};
